export default __webpack_public_path__ + "static/media/chat_icon_bold.d4cf0263.svg";